/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Automation_DescriptionInputs */

const en_directory_taxonomy_use_cases_automation_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Automation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find products that connect steps and reduce repetitive work.`)
};

const zh_directory_taxonomy_use_cases_automation_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Automation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查找能够串联步骤并减少重复工作的产品。`)
};

/**
* | output |
* | --- |
* | "Find products that connect steps and reduce repetitive work." |
*
* @param {Directory_Taxonomy_Use_Cases_Automation_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_automation_description = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Automation_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Automation_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_automation_description(inputs)
	return zh_directory_taxonomy_use_cases_automation_description(inputs)
});
export { directory_taxonomy_use_cases_automation_description as "directory.taxonomy.use-cases.automation.description" }